/* eslint-disable react-dom/no-dangerously-set-innerhtml */
import { isArray, isString } from 'lodash-es'


import { useState } from 'react';
import { cls } from 'tagged-classnames-free';
interface IFaqItemProps {
  title: React.ReactNode
  desc: React.ReactNode
  isCms: boolean
}

export const FaqItem: React.FC<IFaqItemProps> = ({ title, desc, isCms }) => {
  const [open, setOpen] = useState<boolean>(false)
  return (
    <div
      onClick={() => {
        setOpen(!open)
      }}
      className='bg-f-bg-container border-f-border cursor-pointer rounded-2xl border p-4 md:p-6'
    >
      <div className='flex items-center justify-between'>
        {isString(title) ? (
          <h3
            className='font-semibold md:text-lg'
            dangerouslySetInnerHTML={{ __html: title }}
          />
        ) : (
          <h3 className='font-semibold md:text-lg'>{title}</h3>
        )}
        <span
          className={cls`${open ? 'i-com--minus' : 'i-com--plus'} text-f-text size-6`}
        ></span>
      </div>
      <div
        className={cls`
          transition duration-1000 ease-in-out
           ${open ? 'h-auto opacity-100' : 'h-0 overflow-hidden opacity-0'}
        `}
      >
        {isCms ? (
          isString(desc) ? (
            <p
              className='text-f-other-10 pt-3 text-sm md:text-base'
              dangerouslySetInnerHTML={{ __html: desc }}
            />
          ) : isArray(desc) ? (
            <div className='text-f-other-10 space-y-3 pt-3 text-sm md:text-base'>
              {desc.map((a, b) => {
                return <p key={b} dangerouslySetInnerHTML={{ __html: a }} />
              })}
            </div>
          ) : (
            <div className='text-f-other-10 space-y-3 pt-3 text-sm md:text-base'>
              {desc}
            </div>
          )
        ) : isString(desc) ? (
          <p className='text-f-other-10 pt-3 text-sm md:text-base'>{desc}</p>
        ) : (
          <div className='text-f-other-10 space-y-3 pt-3 text-sm md:text-base'>
            {desc}
          </div>
        )}
      </div>
    </div>
  )
}
